import PropTypes from 'prop-types'
import React from 'react'

import SummaryTitle from './components/SummaryTitle'
import { CSSTransitionGroup } from '../CSSTransitionGroup'

class Summary extends React.Component {
  render() {
    const {
      showFullSummary,
      onHandleToggleSummary,
      rightElement,
      children,
    } = this.props

    return (
      <div className="bg-white w-100 z-2 flex-auto flex flex-column">
        <SummaryTitle
          onClick={onHandleToggleSummary}
          showDetails={showFullSummary}
          rightElement={rightElement}
        />

        <div
          className={`${
            showFullSummary ? 'flex' : 'dn'
          } flex-l overflow-auto flex-auto`}
        >
          <CSSTransitionGroup
            transitionName="content"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
            className="flex flex-auto"
          >
            {children}
          </CSSTransitionGroup>
        </div>
      </div>
    )
  }
}

Summary.propTypes = {
  showFullSummary: PropTypes.bool,
  onHandleToggleSummary: PropTypes.func,
  rightElement: PropTypes.node,
  children: PropTypes.node,
}

export default Summary
